import React from 'react'

const Burger = () => {
  return (
    <>
    <div className="main">
    <div className='burger'>
        <div className="burger-1"></div>
        <div className="burger-1"></div>
        <div className="burger-1"></div>
    </div>



    </div>



    </>
  )
}

export default Burger